// extracted by mini-css-extract-plugin
export default {"circles":"statistics_circles__WYJng","cardVersion":"statistics_cardVersion__fJ1rY","container":"statistics_container__qMsr5","card":"statistics_card__-p5sn"};